import { useScrollReveal } from "../../hooks/useScrollReveal";

type AnimationVariant = "fade-up" | "fade-down" | "fade-left" | "fade-right" | "fade-scale" | "fade";

interface ScrollRevealProps {
  children: React.ReactNode;
  variant?: AnimationVariant;
  delay?: number;
  duration?: number;
  threshold?: number;
  className?: string;
  as?: keyof React.JSX.IntrinsicElements;
}

const variantInit: Record<AnimationVariant, string> = {
  "fade-up":    "opacity-0 translate-y-10",
  "fade-down":  "opacity-0 -translate-y-10",
  "fade-left":  "opacity-0 translate-x-10",
  "fade-right": "opacity-0 -translate-x-10",
  "fade-scale": "opacity-0 scale-95",
  "fade":       "opacity-0",
};

const variantDone: Record<AnimationVariant, string> = {
  "fade-up":    "opacity-100 translate-y-0",
  "fade-down":  "opacity-100 translate-y-0",
  "fade-left":  "opacity-100 translate-x-0",
  "fade-right": "opacity-100 translate-x-0",
  "fade-scale": "opacity-100 scale-100",
  "fade":       "opacity-100",
};

export default function ScrollReveal({
  children,
  variant = "fade-up",
  delay = 0,
  duration = 650,
  threshold = 0.1,
  className = "",
}: ScrollRevealProps) {
  const { ref, isVisible } = useScrollReveal({ threshold });

  return (
    <div
      ref={ref}
      className={`transition-all ease-out will-change-transform ${
        isVisible ? variantDone[variant] : variantInit[variant]
      } ${className}`}
      style={{
        transitionDuration: `${duration}ms`,
        transitionDelay: isVisible ? `${delay}ms` : "0ms",
      }}
    >
      {children}
    </div>
  );
}
